import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UI_Header from '../components/UI_Header';
import UI_Ribbon_Main from '../components/UI_Ribbon_Main';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import ContextProviderAccountManagementSelectedAccount from '../Contexts/Context_AccountManagement_SelectedAccount';
import ContextProviderAccountManagementRefreshList from '../Contexts/Context_AccountManagement_RefreshList';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useProperties } from '../Contexts/Context_App_Properties';
import { useAuth } from '../Contexts/AuthContext';
import { useTemplating } from '../Contexts/Context_Templating';
import { useReporting } from '../Contexts/Context_Reporter';
import UI_Subwindows from '../components/UI_Subwindows';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_Templating from '../Contexts/Context_Templating';
import Context_Provider_Accounts from '../Contexts/Context_Accounts';
import Context_Provider_MapRenderer from '../Contexts/Context_MapRenderer';
import Context_Provider_ScheduleManagement from '../Contexts/Context_ScheduleManagement';
import Context_Provider_Reporting from '../Contexts/Context_Reporter';
import { useStatus } from '../Contexts/Context_Status_Global';

import Panel_User_Center from '../components/AccountManagement/Panel_User_Center';

import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import UI_Icon from '../components/ERUMAUI/UI_Icons';

import Icon_Arrow_Left from '../Assets/Icons/Icon_Arrow_Left.png';
import Icon_Reports from '../Assets/Icons/Icon_Reports.png';
import Icon_Calendar from '../Assets/Icons/Icon_Calendar.png';
import Icon_Table from '../Assets/Icons/Icon_Table.png';
import Icon_Room from '../Assets/Icons/Icon_Room.png';
import Icon_Map from '../Assets/Icons/Icon_Map.png';
import Icon_ReservationSlip from '../Assets/Icons/Icon_ReservationSlip.png';
import Icon_User from '../Assets/Icons/Icon_User.png';
import Icon_PDF from '../Assets/Icons/Icon_PDF.png';
import Icon_Image from '../Assets/Icons/Icon_Image.png';
import Icon_Print from '../Assets/Icons/Icon_Print.png';

import Subwindow_Modal_UnsavedChanges from '../components/Subwindow_Modal_UnsavedChanges';
import Subwindow_User_Edit from '../components/AccountManagement/Subwindow_User_Edit';
import Subwindow_Modal_User_IncorrectPassword from '../components/AccountManagement/Subwindow_Modal_User_IncorrectPassword';
import Subwindow_Modal_User_Logout from '../components/AccountManagement/Subwindow_Modal_User_Logout';


export default function DR_Main() {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const location = useLocation();
    const { Slide_Switch } = useStatus();
    const { Account, Loading, Logout } = useAuth();
    const { User_Permission } = useAccounts();
    const { Templates_Edit_Save_Attempt, Template_Editor_Unsaved } = useTemplating();
    const { Report_Orientation, Export_AsPDF, Export_AsImage, Export_AsPrintable } = useReporting();

    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");
    }, []);

    useEffect(() => {
        // console.log(Account?.Access.Reservation.Create);
    }, [location.pathname]);

    // Match Slide_ID with a slide property on App_Properties.
    const [Composition_Slide, Composition_Slide_Set] = useState([]);
    const [Template_Save, Template_Save_Set] = useState({ State: false });
    useEffect(() => {
        // console.log(Template_Editor_Unsaved);
        if (Template_Editor_Unsaved) {
            Template_Save_Set({ State: true });
        } else {
            Template_Save_Set({ State: false });
        }
    }, [Template_Editor_Unsaved]);

    const [Composition_Navigation, Composition_Navigation_Set] = useState(null);


    useEffect(() => {
        Composition_Slide_Set([
            {
                Slide_ID: "User",
                Panel_Left: null,
                Panel_Center: <Panel_User_Center />,
                Panel_Right: null,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            }
        ]);
        Composition_Navigation_Set([
            {
                Routes: ["/"],
                Destination: "/home",
                Icon: Icon_Arrow_Left,
                Text: "Back to home",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/user", "/user/manage"],
                Destination: "/user",
                Icon: Icon_User,
                Text: "Manage your account",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            }
        ])
    }, [Account, location.pathname]);

    // Define all the subwindows the page's slides use
    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_General_UnsavedChanges",
            Component: <Subwindow_Modal_UnsavedChanges />
        },
        {
            ID: "Window_User_Edit",
            Component: <Subwindow_User_Edit />
        },
        {
            ID: "Window_User_IncorrectPassword",
            Component: <Subwindow_Modal_User_IncorrectPassword />
        },
        {
            ID: "Window_User_Logout",
            Component: <Subwindow_Modal_User_Logout />
        }
    ]);

    return (

        <ui-main>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <UI_Header />
            <UI_NavigationRail Composition={Composition_Navigation} />
            <ContextProviderAccountManagementSelectedAccount>
                <ContextProviderAccountManagementRefreshList>
                    <UI_Slide_Manager Composition={Composition_Slide} />
                </ContextProviderAccountManagementRefreshList>
            </ContextProviderAccountManagementSelectedAccount>
        </ui-main>



    )
}